<script setup lang="ts">
definePageMeta({
    hidePromotions: true
})

const route = useRoute()
const slug = route.params?.slug as string

const { data: pressArticle } = await usePressArticleData(slug)
const { data: pressArticles } = await usePressData()
</script>

<template>
    <NimbusPressDetails
        :text="{
            back: 'Tilbage',
            otherNews: 'Andre artikler og presse'
        }"
        no-posts-text="Vi kunne desværre ikke finde nogle indlæg. Venligst opdater siden eller prøv igen senere."
        :article="pressArticle"
        :articles="pressArticles ?? undefined"
    />
</template>
